<template>
  <div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label for="lat">Latitud</label>
          <input
            type="number"
            step="any"
            v-model.number="reportedCenter.lat"
            class="form-control"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="lng">Longitud</label>
          <input
            type="number"
            step="any"
            v-model.number="reportedCenter.lng"
            class="form-control"
          />
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label for="radius">Radio</label>
          <input type="number" v-model="radius" class="form-control" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <gmap-map
          :center="center"
          :zoom="15"
          style="width: 100%; height: 400px"
          ref="map"
          @center_changed="update('reportedCenter', $event)"
          @bounds_changed="update('bounds', $event)"
        >
          <!-- Icono de la ubicacion del sitio -->
          <gmap-marker
            :position="marker_sitio.position"
            :icon="marker_sitio.icon"
          ></gmap-marker>
          <!-- Geocerca -->
          <gmap-circle
            v-if="displayCircle"
            :center="reportedCenter"
            :bounds="circleBounds"
            :radius="parseFloat(radius)"
            :options="{ editable: true }"
            @radius_changed="editarCirculo('radius', $event)"
            @bounds_changed="editarCirculo('bounds', $event)"
          ></gmap-circle>
        </gmap-map>
      </div>
    </div>
    <div class="row">
      <div class="col">
        Lat: {{ reportedCenter.lat }}, Lng: {{ reportedCenter.lng }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SitioMapCir",

  data() {
    return {
      marker_sitio: {},
      center: {
        lat: 4.651371,
        lng: -74.071509,
      },
      reportedCenter: {
        lat: 4.651371,
        lng: -74.071509,
      },
      places: [],
      edited: null,
      displayCircle: true,
      circleBounds: {},
      mapBounds: {},
      radius: 1000,
      url_docs: process.env.VUE_APP_API_URL,
      sitio_icon: "/image/iconos/default.png",
    };
  },

  methods: {
    initCir() {
      if (
        this.$parent.formGeocerca.latitud !== undefined &&
        this.$parent.formGeocerca.longitud !== undefined
      ) {
        this.reportedCenter = {
          lat: parseFloat(this.$parent.formGeocerca.latitud),
          lng: parseFloat(this.$parent.formGeocerca.longitud),
        };
        this.center = {
          lat: parseFloat(this.$parent.formGeocerca.latitud),
          lng: parseFloat(this.$parent.formGeocerca.longitud),
        };
        this.radius = parseFloat(this.$parent.formGeocerca.radio);
        this.marker_sitio = {
          position: {
            lat: parseFloat(this.$parent.$parent.form.latitud),
            lng: parseFloat(this.$parent.$parent.form.longitud),
          },
          icon: this.url_docs + this.sitio_icon,
        };
      }
    },
    update(field, event) {
      if (field === "reportedCenter") {
        this.reportedCenter = {
          lat: event.lat(),
          lng: event.lng(),
        };
      } else if (field === "bounds") {
        this.mapBounds = event;
      } else {
        this.$set(this, field, event);
      }
    },
    editarCirculo(prop, value) {
      if (prop === "radius") {
        this.radius = value;
      } else if (prop === "bounds") {
        this.radius = value;
      }
    },
  },

  mounted() {
    this.initCir();
  },
};
</script>
